import { render, staticRenderFns } from "./BaseDatos.vue?vue&type=template&id=4ae6318e&"
import script from "./BaseDatos.vue?vue&type=script&lang=js&"
export * from "./BaseDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports